"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationDataToDataTransformer = void 0;
const ValuationData_1 = require("../Model/ValuationData");
const PriceEvaluation_1 = require("../Model/PriceEvaluation");
class ValuationDataToDataTransformer {
    /**
     * @inheritDoc
     */
    to(valuationData) {
        return {
            priceValuations: valuationData.getPriceEvaluations(),
            outstandingFinanceValue: valuationData.getOutstandingFinanceValue(),
            createdAt: valuationData.getCreatedAt(),
            updatedAt: valuationData.getUpdatedAt(),
            expiresAt: valuationData.getExpiresAt(),
            totalEquity: valuationData.getTotalEquity()
        };
    }
    /**
     * @inheritDoc
     */
    from(data) {
        let valuationData = new ValuationData_1.default()
            .setPriceEvaluations(data && data.priceEvaluations && data.priceEvaluations.map(item => new PriceEvaluation_1.default()
            .setEvaluationType(item.evaluationType)
            .setEvaluationValue(item.evaluationValue)))
            .setOutstandingFinanceValue(data.outstandingFinanceValue)
            .setTotalEquity(data.totalEquity)
            .setCreatedAt(data.createdAt)
            .setExpiresAt(data.expiresAt)
            .setUpdatedAt(data.updatedAt);
        return valuationData;
    }
}
exports.ValuationDataToDataTransformer = ValuationDataToDataTransformer;
